<div
  class="pooler-types-list"
  *ngIf="user$ | async">
  <mat-card class="mat-elevation-z2">
    <mat-card-title> </mat-card-title>
    <mat-card-content>
      <div
        class="row"
        *ngFor="let poolerType of poolerTypes$ | async; trackBy: trackById">
        <div class="col">
          <div class="pooler-type-row">
            <div class="pooler-type-details">
              <mat-form-field>
                <mat-label>{{
                  ("title" | i18n) || "Titel" | titlecase
                }}</mat-label>
                <input
                  matInput
                  required
                  [(ngModel)]="poolerType.displayName"
                  [name]="'displayName-' + poolerType.id" />
              </mat-form-field>

              <mat-checkbox
                [(ngModel)]="poolerType.bookingWarningEnabled"
                name="bookingWarningEnabled"
                data-cy="pooler-type-booking-warning-enabled">
                {{
                  ("bookingWarningEnabled" | i18n) ||
                    "Warnung bei Buchung aktivieren"
                }}
              </mat-checkbox>
              <mat-form-field *ngIf="poolerType.bookingWarningEnabled">
                <mat-label>{{
                  ("bookingWarningMessage" | i18n) || "Warnung bei Buchung"
                    | titlecase
                }}</mat-label>
                <input
                  matInput
                  [(ngModel)]="poolerType.bookingWarningMessage"
                  [name]="'bookingWarningMessage-' + poolerType.id" />
              </mat-form-field>
            </div>
            <div class="pooler-type-buttons">
              <button
                class="pooler-type-button"
                mat-button
                type="button"
                (click)="cancelChanges(poolerType.id)"
                [matTooltip]="('cancel' | i18n) || 'Abbrechen' | titlecase">
                <mat-icon
                  class="pooler-type-button-icon"
                  svgIcon="close"></mat-icon>
              </button>
              <button
                class="pooler-type-button save-button"
                mat-button
                type="button"
                (click)="savePoolerType(poolerType.id)"
                [matTooltip]="('save' | i18n) || 'Speichern' | titlecase">
                <mat-icon
                  class="pooler-type-button-icon"
                  svgIcon="save"></mat-icon>
              </button>
              <button
                class="pooler-type-button delete-button"
                mat-button
                type="button"
                (click)="deletePoolerTypeDialog(poolerType.id)"
                [matTooltip]="('remove' | i18n) || 'Löschen' | titlecase">
                <mat-icon
                  class="pooler-type-button-icon"
                  svgIcon="delete-trash-remove"></mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        class="row"
        *ngFor="
          let poolerType of poolerTypesInCreation$ | async;
          let i = index
        ">
        <div class="col">
          <div class="pooler-type-row">
            <div class="pooler-type-details">
              <mat-form-field>
                <mat-label>{{
                  ("title" | i18n) || "Titel" | titlecase
                }}</mat-label>
                <input
                  matInput
                  required
                  [(ngModel)]="poolerType.displayName"
                  [name]="'newDisplayName-' + i" />
              </mat-form-field>
              <mat-checkbox
                [(ngModel)]="poolerType.bookingWarningEnabled"
                name="bookingWarningEnabled"
                data-cy="pooler-type-booking-warning-enabled">
                {{
                  ("bookingWarningEnabled" | i18n) ||
                    "Warnung bei Buchung aktivieren"
                }}
              </mat-checkbox>
              <mat-form-field *ngIf="poolerType.bookingWarningEnabled">
                <mat-label>{{
                  ("bookingWarningMessage" | i18n) || "Warnung bei Buchung"
                    | titlecase
                }}</mat-label>
                <input
                  matInput
                  [(ngModel)]="poolerType.bookingWarningMessage"
                  [name]="'newBookingWarningMessage-' + i" />
              </mat-form-field>
            </div>
            <div class="pooler-type-buttons">
              <button
                class="pooler-type-button"
                mat-button
                type="button"
                (click)="cancelNewPoolerType(i)"
                [matTooltip]="('cancel' | i18n) || 'Abbrechen' | titlecase">
                <mat-icon
                  class="pooler-type-button-icon"
                  svgIcon="close"></mat-icon>
              </button>
              <button
                class="pooler-type-button save-button"
                mat-button
                type="button"
                (click)="saveNewPoolerType(i)"
                [matTooltip]="('save' | i18n) || 'Speichern' | titlecase">
                <mat-icon
                  class="pooler-type-button-icon"
                  svgIcon="save"></mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col">
          <button
            class="outline-pill-button icon-left"
            type="button"
            data-cy="add-pooler-type-button"
            (click)="addNewPoolerType()">
            <mat-icon
              class="custom-text-icon-button-icon"
              svgIcon="add-circle-plus"></mat-icon>
            {{ ("addPoolerType" | i18n) || "Poolertyp hinzufügen" | titlecase }}
          </button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
